<template>
    <div>
      <slot :data="cData" :loading="loading" :empty="empty"></slot>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <!-- <div slot="spinner">Loading...</div> -->
        <div slot="no-more" class="nomore_data">
          <span v-if="text != ''">{{text}}</span>
        </div>
        <div slot="no-results" class="noresult_data">
          <van-image class="no_goods" :src="require('../assets/bx/acc/no_goods.png')"/>
          {{ params.goods_name == '' ? nrtxt: '未搜索到相关商品' }}
        </div>
        <div slot="error" class="result_error" slot-scope="{ trigger }">
          出错了，请刷新&nbsp;&nbsp;<a class="here" href="javascript:;" @click="trigger">here</a>
        </div>
      </infinite-loading>
    </div>
  </template>
  
  <script>
    import {
      debounce
    } from 'riku-verycloud'
    import InfiniteLoading from "vue-infinite-loading";
    export default {
      name: "home-scroll2",
      components: {
        InfiniteLoading,
      },
      data() {
        return {
          page: 1,
          data: [],
          loading: 0,
          infiniteId: 1,
          destroyed: false,
          isActive: true,
          pendingRefresh: false
        };
      },
      //返回时要修改
      props: {
        text: {
          type: String,
          default: "暂无更多",
        },
        pagesize: {
          type: Number,
          default: 10,
        },
        url: {
          type: String,
          required: true,
        },
        params: {
          type: Object,
          default () {
            return {};
          },
        },
        refreshKey: [String, Number],
        nrtxt: {
          type: String,
          default: "暂无数据",
        },
        computeData: Function,
        method: {
          type: String,
          default: "post",
        }
      },
      computed: {
        sendData() {
          return {
            ...this.params,
            page: this.page
          };
        },
        trigger() {
          return this.url + "?" + this.$QueryString.stringify(this.params);
        },
        cData() {
          return (
            (typeof this.computeData === "function" ?
              this.computeData(this.data) :
              this.data) || []
          );
        }, 
        empty() {
          return !this.cData.length;
        },
      },
      activated() {
        this.isActive = true
        if (this.pendingRefresh) {
          this.pendingRefresh = false
          this.refresh()
        }
      },
      deactivated() {
        this.isActive = false
      },
      beforeDestroy() {
        this.destroyed = true
      },
      methods: {
        infiniteHandler: debounce(function ($state) { 
            if (this.destroyed) return
            this.loading++;
            this.$Ajax(this.url, this.sendData, this.method)
              .then(rs => {
                if (this.destroyed) return
                this.page++;
                if (
                  rs.code == 200 && 
                  rs.data &&
                  rs.data.list instanceof Array &&
                  rs.data.list.length > 0
                ) {
                  this.$emit("on-fetch", {
                    data: rs.data.list,
                    total: rs.data.page_info.total,
                  });
                  this.data.push(...rs.data.list);
                  $state && $state.loaded && $state.loaded();
                } 
                const total = rs.data && rs.data.page_info ? Number(rs.data.page_info.total) : 0
                const pageSize = rs.data && rs.data.page_info ? Number(rs.data.page_info.page_size) : 10
                if (!total || this.page - 1 >= Math.ceil(total / pageSize)) {
                  $state && $state.complete && $state.complete();
                }
              })
              .finally(() => {
                if (this.destroyed) return
                this.loading--;
              });

        }),
        refresh() {
          if (this.destroyed) return
          if (!this.isActive) {
            this.pendingRefresh = true
            return
          }
          this.page = 1;
          this.data = [];
          this.infiniteId++;
        },
      },
      watch: {
        trigger() {
          if (this.destroyed) return
          if (!this.isActive) {
            this.pendingRefresh = true
            return
          }
          this.refresh()
        },
        refreshKey() {
          if (this.destroyed) return
          if (!this.isActive) {
            this.pendingRefresh = true
            return
          }
          this.refresh()
        },
      },
    };
  </script>
  
  <style lang="less" scoped>
    .nomore_data,
    .noresult_data,
    .result_error {
      color: #aaa;
      font-size: 1.4rem;
      padding: 1rem 0;
  
      .van-divider {
        margin: 0;
        font-size: 1.2rem;
        line-height: unset;
      }
  
      .van-icon-warning {
        font-size: 1.4rem;
        margin-right: 0.6rem;
      }
  
      .here {
        color: var(--theme);
      }
    }
    .noresult_data {
      .no_goods {
        display: block;
        margin: 2rem auto .7rem;
        width: 21rem;
        height: 13.4rem;
      }
    }
  </style>